<template>
  <div class="aspect-square max-w-80 m-8 relative">
    <div class="overflow-hidden w-full h-full rounded-xl">
      <qrcode-stream class="object-contain" @detect="onDetect" @init="onInit" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import type { DetectedBarcode } from 'vue-qrcode-reader'
import { QrcodeStream } from 'vue-qrcode-reader'

import { sleep } from '@last/core'

const emit = defineEmits<{
  close: []
  cancel: []
  error: []
  found: [value: string]
}>()

const qrDetected = ref(true)

async function onDetect(result: DetectedBarcode[]) {
  qrDetected.value = true
  await sleep(1000)
  qrDetected.value = false
  emit('found', result[0].rawValue)
}

async function onInit(promise: Promise<void>) {
  try {
    await promise
  } catch {
    emit('error')
  }
}
</script>
